import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full" }
const _hoisted_2 = { class: "flex items-center gap-0.5" }
const _hoisted_3 = { class: "w-8 h-8 rounded-lg flex items-center justify-center" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "text-xs ct-fg-3" }
const _hoisted_7 = { class: "flex items-center" }

import { computed } from "vue";
import { PAGE_SECTION_KINDS } from "@/apps/page/services/page.service";
import { useBlocks } from "@/apps/page/services/blocks/useBlocks";
import { InvisibleIcon, PencilSquareIcon, RecycleBinIcon, VisibleIcon } from "@easy/ui/icons";
import { ButtonTertiaryIconXs } from "@easy/ui/buttons";
import { useActions } from "@/store/vuex-composition-mappers";
import { PageSection } from "@/apps/page/page.interfaces";
import { useSections } from "@/apps/page/services/useSections";


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionListCard',
  props: {
    section: {}
  },
  setup(__props: any) {

const props = __props;

// @ts-expect-error
const { toggleHideSection, removeSection } = useActions("page", [
    "toggleHideSection",
    "removeSection",
]);

const { getBlockWithTypeMetadata } = useBlocks();
const { sectionTypes } = useSections();

const isBlock = computed(() => props.section.kind === PAGE_SECTION_KINDS.BLOCK);

const sectionDetails = computed(() => {
    if (isBlock.value) {
        const blockWithTypeMetadata = getBlockWithTypeMetadata(props.section.typeId || "");

        if (!blockWithTypeMetadata) {
            return null;
        }

        const { block, blockType } = blockWithTypeMetadata;

        return {
            title: blockType.title,
            subtitle: block.name,
            icon: blockType.icon,
        };
    }

    // Section is TOOL type, so:
    const { projectData, type, projectId } = props.section;
    const { name, uuid } = projectData || {};
    return {
        title: name || projectId,
        subtitle: `(${type}) /${uuid || ""}`,
        icon: sectionTypes.value.find((s) => s.tool === type)?.icon,
    };
});

const forwardEdit = () => {
    // do nothing
    // @click is asigned on this component and will be handled by the parent component
};

return (_ctx: any,_cache: any) => {
  return (sectionDetails.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["cursor-pointer ring-1 ring-inset ct-ring-1 hover:ct-ring-brand ct-bg-1--alt rounded-lg px-1 py-3 flex items-center space-x-2 shadow-sm shadow-gray-900/5 group", {
            'ct-ring-brand ct-ring-focus': false,
            'opacity-50': _ctx.section.isHidden,
        }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(sectionDetails.value.icon), { class: "ct-fg-2 h-4 w-4" }))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(sectionDetails.value.title), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(sectionDetails.value.subtitle), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(ButtonTertiaryIconXs), {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(removeSection)(_ctx.section.id)), ["stop"])),
              class: "!hidden group-hover:!block"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(RecycleBinIcon))
              ]),
              _: 1
            }),
            _createVNode(_unref(ButtonTertiaryIconXs), {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(toggleHideSection)(_ctx.section.id)), ["stop"])),
              class: _normalizeClass({ '!hidden group-hover:!block': !_ctx.section.isHidden })
            }, {
              default: _withCtx(() => [
                (!_ctx.section.isHidden)
                  ? (_openBlock(), _createBlock(_unref(VisibleIcon), { key: 0 }))
                  : (_openBlock(), _createBlock(_unref(InvisibleIcon), { key: 1 }))
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_unref(ButtonTertiaryIconXs), { onClick: forwardEdit }, {
              default: _withCtx(() => [
                _createVNode(_unref(PencilSquareIcon))
              ]),
              _: 1
            })
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})